import { render, staticRenderFns } from "./edit-model.vue?vue&type=template&id=e48de196&scoped=true&"
import script from "./edit-model.vue?vue&type=script&lang=js&"
export * from "./edit-model.vue?vue&type=script&lang=js&"
import style0 from "./edit-model.vue?vue&type=style&index=0&id=e48de196&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48de196",
  null
  
)

export default component.exports